import { useCallback } from "react"

import { useTranslation } from "@l2r-front/l2r-i18n"
import { parseFormattedNumber } from "@l2r-front/l2r-utils"

import { I18N_NAMESPACE } from "../../../../common/constants/i18n"
import { useTaskUpdate } from "../../hooks/mutations/useTaskMutation"
import { useProjectTaskTypes, useTaskTypes } from "../../hooks/queries/useTaskType"

import { RoadworkTaskForm } from "./RoadworkTaskForm"

export const RoadworkTaskEditFormPost = (props) => {

    const {
        onClose,
        onSubmitting,
        onChange,
        task,
        ...formProps
    } = props

    const { t } = useTranslation(I18N_NAMESPACE)

    const {
        data: taskTypes,
        isLoading: isLoadingTaskTypes,
        isError: isErrorTaskTypes,
    } = useTaskTypes()

    const {
        data: projectTaskTypes,
        isLoading: isLoadingProjectTaskTypes,
        isError: isErrorProjectTaskTypes,
    } = useProjectTaskTypes()

    const roadworkTaskMutation = useTaskUpdate({
        errorSnackbarMessage: t(I18N_NAMESPACE, "components.roadworkDetailsForm.snackbar.error"),
        successSnackbarMessage: t(I18N_NAMESPACE, "components.roadworkDetailsForm.snackbar.success"),
        onSuccess: () => onClose(false),
        onError: () => {
            onSubmitting(false)
        },
    })

    const onSubmit = useCallback((formValues) => {
        const values = {
            uuid: task.uuid,
            ...formValues,
            cost: parseFormattedNumber(formValues.cost),
            quantity: parseFormattedNumber(formValues.quantity),
        }
        roadworkTaskMutation.mutate(values)
        onSubmitting(true)
    }, [task, roadworkTaskMutation, onSubmitting])

    if (isLoadingProjectTaskTypes || isLoadingTaskTypes) {
        return null
    }

    if (isErrorProjectTaskTypes || isErrorTaskTypes) {
        return null
    }

    return <RoadworkTaskForm
        isSubmitting={roadworkTaskMutation.isPending}
        onSubmit={onSubmit}
        onCancel={() => onClose()}
        onChange={onChange}
        task={task}
        projectTasksInfo={projectTaskTypes}
        tasksInfo={taskTypes}
        {...formProps}
    />
}